import React, { useEffect, useMemo, useRef, useState } from 'react';
import ConvertStringToHtml from '../../components/ConvertStringToHtml';
import { useGroupChatContext } from '../../context/groupchatContext';
import MessageList from '../groupChat/messageList';
import { useStatusChangeChatMutation } from '../../services/chatService';
import { FaSpinner } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { getBaseUrl } from '../../helpers/utility';

const BotchatWindow = React.memo(({msgDetail, setReady}) => {

    const scrollRef = useRef();
    const messagesRef = useRef(null);
    const allMessagesRef = useRef(null);
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const groupChatContext = useGroupChatContext();

    const {authData, selectedChat} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
    }));
    
    // const [statusChangeChat, {isLoading}]  = useStatusChangeChatMutation({location_id: selectedChat?.location?.uuid});
    const parseInitialBotChatResponse = (text) => {
        const lines = text.split("\n");
        let isSummaryForProvider = false;
        let currentSection = "";
        const parsedArray = [];
        lines.forEach((line) => {
            if (line.trim() === "") {
            // Skip empty lines
            return;
            }
            const colonIndex = line.indexOf(":");
            if (colonIndex > -1 && !isStringStartingWithNumber(line) && !isSummaryForProvider) {
            if (currentSection) {
                // Trim trailing whitespace and newlines from the last section
                currentSection.note_text = currentSection.note_text?.trim();
            }
            // Identify new section title
            currentSection = { title: (line.slice(0, colonIndex).trim().replace(/_/g, ' ')), slug: (line.slice(0, colonIndex).trim().replace(/\s/g, '_').toLowerCase()), note_text: line.slice(colonIndex + 1).trim() };
            parsedArray.push(currentSection);
            console.log(currentSection,"currentSection")
            if (line.slice(0, colonIndex).trim().replace(/_/g, ' ')=="SUMMARY FOR PROVIDER"){
                isSummaryForProvider=true
            }
            } else if (currentSection) {
            // Handle multi-line text for the same section
            currentSection.note_text += "\n" + line;
            //parsedArray[parsedArray.length-1] += "\n" + line;
            }
        });

        if (currentSection && currentSection.note_text && currentSection.note_text!='undefined' && currentSection.note_text?.trim() !== "") {
            // Trim trailing whitespace and newlines from the last section
            currentSection.note_text = currentSection.note_text?.trim();
        }

        return parsedArray;
    };

    function isStringStartingWithNumber(string) {
        const regex = /^\d/;
        return regex.test(string);
    }
    
    let tempBotChatParsedText = "";
    const streamCharacterData = (postData, stream_callback) => {
        let logSql = '';
        if (window.enable_log_sql) {
          logSql = '&log_sql=' + window.enable_log_sql;
        }

        let token = '';
        if(authData?.is_provider){
            token = '&token='+authData.auth
        }
        else{
            token = '&na_auth='+authData.auth
        }
        setIsLoading(true);
        // Fetch the data from the specified URL with a POST request
        fetch(`${getBaseUrl().api_url}/nursing_home_chats/status_change_chat.json?tz=${new Date().getTimezoneOffset()}&practice_id=${authData.practice?.id}&new_chat=1&portal=provider${token}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
        })
        .then((response) => {

        // Check if the response is ok and has the correct content type
            // if (!response.ok || !response.headers.get('content-type').includes('text')) {
            // 	throw new Error('Invalid response');
            // }

            // Get the ReadableStream from the response
            const stream = response.body;
            const reader = stream.getReader();

            // Read and process the data
            readStream(reader, stream_callback);
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
        }).finally(() => {
            setIsLoading(false);
        });
      };
    
      const readStream = (reader, stream_callback) => {
        reader.read().then(({ done, value }) => {
            if (done) {
                if (done == true) {
                    setTimeout(() => {
                        const tempMssgs = cloneDeep(messagesRef?.current).map((msg) => {
                            if(msg?.sender=='eSync' && msg?.status!='done'){
                                return {...msg, status: 'done'}
                            }
                            return msg;
                        });
                        if (tempMssgs && tempMssgs.length > 0) {
                            setMessages(tempMssgs);
                            if (allMessagesRef && allMessagesRef?.current && allMessagesRef?.current.length > 0) {
                                const checkSummary = allMessagesRef?.current?.find((msg) => msg?.slug?.trim() === "conversation_status");
                                if (checkSummary?.note_text == "READY_SEND_SUMMARY_TO_MD") {
                                    const summaryText = allMessagesRef?.current?.find((msg) => msg?.slug?.trim() === "summary_for_provider");
                                    if (summaryText && summaryText?.note_text && summaryText?.note_text?.trim() !== "") {
                                        setReady(summaryText?.note_text?.trim());
                                    }
                                }
                            }
                        }
                        scrollContainerToBottom();
                    }, 1000);
                }
                return;
            }
            // Process the received data chunk (convert from Uint8Array to string)
            const chunk = new TextDecoder('utf-8').decode(value);

            // Use jQuery to update the DOM or perform other tasks
            stream_callback(chunk)
            // Continue reading the stream
            readStream(reader, stream_callback);
        });
    }
    const scrollContainerToBottom = () => {
        setTimeout(() => {
            if (scrollRef?.current?.scrollTo) {
                const scrollHeight = scrollRef?.current?.scrollHeight;
                const height = scrollRef?.current?.clientHeight;
                const maxScrollTop = scrollHeight - height;
                scrollRef.current.scrollTo({top: maxScrollTop > 0 ? maxScrollTop : 0, behavior: "smooth"});
            }
          }, 750);
    }
    useEffect(()=>{
        if(msgDetail?.description){
            setMessages([ ...messages, { message: {type: 'message', text: msgDetail.description}, nurse_id: authData?.id, created: moment()}]);
            scrollContainerToBottom();
            const payload = {pid: selectedChat?.pid, thread_id: msgDetail.thread_id, message: msgDetail.description};
            streamCharacterData(payload, function(data) {
            if (data.indexOf(',"code":') < 0) {
                tempBotChatParsedText = tempBotChatParsedText + data;
                let tempResponse = parseInitialBotChatResponse(tempBotChatParsedText);
                const msgsArray = tempResponse.filter((msg) => msg?.slug?.trim() !== "conversation_status").map((item) => {
                    return { message: {type: 'message', text: item.note_text, slug: item.slug}, sender: 'eSync', created: moment()}
                });
                setMessages(prevMessages => {
                    let tempData = [...prevMessages.filter((msg)=>msg?.sender!='eSync' || msg?.status=='done'), ...msgsArray]
                    messagesRef.current = tempData;
                    return tempData;
                });
                allMessagesRef.current = tempResponse;
                scrollContainerToBottom();
            } else {
                let responseJson = JSON.parse(data);
                console.error("Error in response", responseJson);
            }
            });
        }
    }, [msgDetail])


    return (
        <>
            {isLoading && (
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto absolute inset-0 outline-none focus:outline-none before:absolute before:flex before:w-full before:h-full z-[999]">
                    <FaSpinner className="animate-spin text-green-300-500 ml-1" size={40} />
                </div>
            )}
            <div id="scrollableDiv" ref={scrollRef} className="flex flex-1 flex-col relative min-h-10 max-h-[70vh] overflow-auto px-2">
                <MessageList messages={messages} isSkipTimeBanner={true} />
            </div>
        </>
    );
});

export default BotchatWindow;